import PageContainer from "../../componets/containers/PageContainer";
import {useEffect, useState} from "react";
import Navbar from "../../componets/containers/NavBar";
import Footer from "../../componets/containers/footer";
import dashboardApi from "../../services/dashboardApi";
import Carousel from "react-multi-carousel";
import Str from "../../helpers/Str";
import {BiArea} from "react-icons/bi";
import {BsHouseCheckFill} from "react-icons/bs";

export default function Home() {
    const [loading, setLoading] = useState(true);

    const [banner, setBanner] = useState('');
    const [properties, setProperties]: any [] = useState([]);
    const [equipments, setEquipments]: any [] = useState([]);
    const [vehicles, setVehicles]: any [] = useState([]);

    const getDashboard = async () => {
        const {data, isError} = await dashboardApi.getDashboard();
        if (!isError){
            setBanner(data.banner ? data.banner.image_path : '')
            setProperties(data.propriedades)
            setEquipments(data.equipamentos)
            setVehicles(data.veiculos)
        }
        ;
        setLoading(false);
    }

    useEffect(() => {getDashboard()}, [])

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            partialVisibilityGutter: 40, // this is optional if you are not using partialVisible props
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            partialVisibilityGutter: 30, // this is optional if you are not using partialVisible props
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            partialVisibilityGutter: 30, // this is optional if you are not using partialVisible props
        },
    };

    return(
        <>
            <Navbar/>
            {
                loading ?
                    <div className={'w-full h-[calc(100vh_-_80px)]'}>
                        <span className="flex items-center justify-center w-full h-full h-7">
                            <svg className="animate-spin -ml-1 mr-3 h-[45px] w-[45px] text-[#003641]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="#003641"  strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </span>
                    </div>
                    :
                    <main className="w-full flex justify-center mb-10">
                        <div className={'w-[70%] flex flex-col'}>
                            {
                                banner ?
                                    <div className={'w-full flex justify-center  h-full'}>
                                        {/*<img className="h-[40rem] w-[80rem]" src={banner} alt="image description"/>*/}
                                        <img className="h-[40rem] w-full" src={banner} />
                                    </div>
                                    :
                                    ''
                            }

                            <div className={'w-full flex flex-col h-full mt-5 '}>
                                <div className={'text-2xl font-bold py-2'}>
                                    Últimos imóveis cadastrados
                                </div>
                                {
                                    <div className={'flex flex-col items-center justify-center gap-5'}>
                                    <div className="grid md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 gap-4 ">
                                        {
                                            properties.length > 0 ?
                                            properties.map((property: any) => {
                                                return (
                                                    <div className="flex flex-col max-w-sm rounded overflow-hidden shadow-2xl border p-2">
                                                        <Carousel
                                                            additionalTransfrom={0}
                                                            arrows
                                                            autoPlaySpeed={3000}
                                                            autoPlay
                                                            centerMode={false}
                                                            className=""
                                                            containerClass="container-with-dots"
                                                            dotListClass="z-10"
                                                            draggable
                                                            focusOnSelect={false}
                                                            infinite={property.images.length > 1}
                                                            keyBoardControl
                                                            minimumTouchDrag={80}
                                                            renderButtonGroupOutside={false}
                                                            renderDotsOutside={false}
                                                            responsive={responsive}
                                                            itemClass={'p-3'}
                                                            showDots={property.images.length > 1}
                                                        >
                                                            {
                                                                property.images.map((image: any) => {
                                                                    return (
                                                                        <div
                                                                            className={'w-full flex p-1 gap-1 justify-center items-center '}>
                                                                            <img
                                                                                className={'w-[350px] h-[250px]'}
                                                                                src={image.image_path}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </Carousel>
                                                        <div className="p-1 ">
                                                            <a href={'#'}>
                                                                <h5 className="mb-2 text-[18px] font-bold tracking-tight text-gray-900  w-full flex flex-col items-center">
                                                                    <div>Imóvel {property.tipo.descricao} </div>

                                                                    <div>{property.city.description} - {property.state.description}</div>
                                                                </h5>
                                                            </a>
                                                            <p className="mb-3 font-normal text-gray-700 flex flex-col items-center">
                                                                <div>{property.bairro}</div>
                                                                <div className={'flex w-full items-center justify-center gap-1'}>
                                                                    <BiArea />
                                                                    {
                                                                        property.area_terreno ? <div>{property.area_terreno} <span className={'text-sm'}>m²</span></div> : '-'
                                                                    }

                                                                </div>
                                                                <div className={'flex w-full items-center justify-center gap-1'} >
                                                                    <BsHouseCheckFill />
                                                                    {
                                                                        property.area_construida ? <div>{property.area_construida} <span className={'text-sm'}>m²</span></div> : '-'
                                                                    }

                                                                </div>
                                                            </p>

                                                        </div>
                                                        <div className={'flex justify-between items-center gap-3'}>
                                                            <div className={'px-3 py-2 text-[25px] font-bold text-[#003641]'}>
                                                                {Str.currencyMask(property.valor)}
                                                            </div>
                                                            <a href={'view/imovel/'+property.id} className="inline-flex h-[45px] items-center px-3 py-2 text-sm font-medium text-center text-white bg-[#003641] rounded-lg hover:bg-opacity-80   ">
                                                                Ver imóvel
                                                                <svg className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                                                                     aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                                     fill="none" viewBox="0 0 14 10">
                                                                    <path stroke="currentColor" stroke-linecap="round"
                                                                          stroke-linejoin="round" stroke-width="2"
                                                                          d="M1 5h12m0 0L9 1m4 4L9 9"/>
                                                                </svg>
                                                            </a>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                                :
                                                ''
                                        }


                                    </div>
                                    </div>
                                }
                            </div>
                            <div className={'w-full flex flex-col h-full mt-[50px]'}>
                                <div className={'text-2xl font-bold py-2'}>
                                    Últimos veículos cadastrados
                                </div>
                                <div className={'flex flex-col items-center justify-center gap-5'}>
                                {
                                    vehicles.length > 0 ?
                                        <div className="grid md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 gap-4">
                                            {
                                                vehicles.map((vehicle: any) => {
                                                    return (
                                                        <div className="flex flex-col max-w-sm rounded overflow-hidden shadow-2xl border p-2">
                                                            <Carousel
                                                                additionalTransfrom={0}
                                                                arrows
                                                                autoPlaySpeed={3000}
                                                                autoPlay
                                                                centerMode={false}
                                                                className=""
                                                                containerClass="container-with-dots"
                                                                dotListClass=""
                                                                draggable
                                                                focusOnSelect={false}
                                                                infinite={vehicle.images.length > 1}
                                                                keyBoardControl
                                                                minimumTouchDrag={80}
                                                                renderButtonGroupOutside={false}
                                                                renderDotsOutside={false}
                                                                responsive={responsive}
                                                                itemClass={'p-3'}
                                                                showDots={vehicle.images.length > 1}
                                                            >
                                                                {
                                                                    vehicle.images.map((image: any) => {
                                                                        return (
                                                                            <div
                                                                                className={'w-full flex p-1 gap-1 justify-center items-center '}>
                                                                                <img
                                                                                    className={'w-[350px] h-[250px]'}
                                                                                    src={image.image_path}
                                                                                />
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </Carousel>
                                                            <div className="p-1 ">
                                                                <a href={'#'}>
                                                                    <h5 className="mb-2 text-[18px] font-bold tracking-tight text-gray-900  w-full flex flex-col items-center">
                                                                        <div>{vehicle.marca} {vehicle.modelo}</div>
                                                                    </h5>
                                                                </a>
                                                                <p className="mb-3 font-normal text-gray-700 flex flex-col items-center">
                                                                    <div className={'flex w-full items-center justify-center gap-1'}>
                                                                        <div>{vehicle.ano}</div>
                                                                    </div>
                                                                </p>

                                                            </div>
                                                            <div className={'flex justify-between items-center gap-3'}>
                                                                <div className={'px-3 py-2 text-[25px] font-bold text-[#003641]'}>
                                                                    {Str.currencyMask(vehicle.valor)}
                                                                </div>
                                                                <a href={'view/veiculo/'+vehicle.id} className="inline-flex h-[45px] items-center px-3 py-2 text-sm font-medium text-center text-white bg-[#003641] rounded-lg hover:bg-opacity-80   ">
                                                                    Ver veículo
                                                                    <svg className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                                                                         aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                                         fill="none" viewBox="0 0 14 10">
                                                                        <path stroke="currentColor" stroke-linecap="round"
                                                                              stroke-linejoin="round" stroke-width="2"
                                                                              d="M1 5h12m0 0L9 1m4 4L9 9"/>
                                                                    </svg>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }

                                        </div>
                                        :
                                        ''
                                }
                                </div>
                            </div>
                            <div className={'w-full flex flex-col h-full mt-[50px]'}>
                                <div className={'text-2xl font-bold py-2'}>
                                    Últimos equipamentos cadastrados
                                </div>
                                <div className={'flex flex-col items-center justify-center gap-5'}>
                                {
                                    equipments.length > 0 ?
                                        <div className="grid md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 gap-4">
                                            {
                                                equipments.map((equipment: any) => {
                                                    return (
                                                        <div className="flex flex-col max-w-sm rounded overflow-hidden shadow-2xl border p-2">
                                                            <Carousel
                                                                additionalTransfrom={0}
                                                                arrows
                                                                autoPlaySpeed={3000}
                                                                autoPlay
                                                                centerMode={false}
                                                                className=""
                                                                containerClass="container-with-dots"
                                                                dotListClass=""
                                                                draggable
                                                                focusOnSelect={false}
                                                                infinite={equipment.images.length > 1}
                                                                keyBoardControl
                                                                minimumTouchDrag={80}
                                                                renderButtonGroupOutside={false}
                                                                renderDotsOutside={false}
                                                                responsive={responsive}
                                                                itemClass={'p-3'}
                                                                showDots={equipment.images.length > 1}
                                                            >
                                                                {
                                                                    equipment.images.map((image: any) => {
                                                                        return (
                                                                            <div
                                                                                className={'w-full flex p-1 gap-1 justify-center items-center '}>
                                                                                <img
                                                                                    className={'w-[350px] h-[250px]'}
                                                                                    src={image.image_path}
                                                                                />
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </Carousel>
                                                            <div className="p-1 ">
                                                                <a href={'#'}>
                                                                    <h5 className="mb-2 text-[18px] font-bold tracking-tight text-gray-900  w-full flex flex-col items-center">
                                                                        <div>{equipment.nome}</div>
                                                                    </h5>
                                                                </a>
                                                                <p className="mb-3 font-normal text-gray-700 flex flex-col items-center">
                                                                    <div className={'flex w-full items-center justify-center gap-1'}>
                                                                        <div>{equipment.descricao}</div>
                                                                    </div>
                                                                </p>

                                                            </div>
                                                            <div className={'flex justify-between items-center gap-3'}>
                                                                <div className={'px-3 py-2 text-[25px] font-bold text-[#003641]'}>
                                                                    {Str.currencyMask(equipment.valor)}
                                                                </div>
                                                                <a href={'view/equipamento/'+equipment.id} className="inline-flex h-[45px] items-center px-3 py-2 text-sm font-medium text-center text-white bg-[#003641] rounded-lg hover:bg-opacity-80   ">
                                                                    Ver equipamento
                                                                    <svg className="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
                                                                    </svg>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }

                                        </div>
                                        :
                                        ''
                                }
                                </div>
                            </div>
                        </div>
                    </main>
            }

            <Footer fixed={false}/>
        </>
    )

    /*return(
        <PageContainer list>
            {
                    <div className={'flex flex-col items-center justify-center gap-4 md:mb-[4rem] '}>

                        Home

                    </div>
            }
        </PageContainer>
    )*/
}